import { Component } from '@angular/core';

@Component({
  selector: 'wsb-trumpipsum',
  templateUrl: './trumpipsum.component.html',
  styleUrls: ['./trumpipsum.component.scss'],
  standalone: false
})
export class TrumpipsumComponent {
  constructor() {}
}
